/** /admin/access-logs — 原文访问审计(teacher-role spec §5.6,append-only)。 */
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { authHeaders } from "@/api/school";

interface LogRow {
  id: string; accessor: string; teacher: string; session_id: string;
  reason: string; accessed_at: string;
}

export default function AccessLogsPage() {
  const { t } = useTranslation();
  const logs = useQuery({
    queryKey: ["admin", "access-logs"],
    queryFn: async () => {
      const r = await fetch("/api/school/admin/access-logs", {
        credentials: "include", headers: authHeaders(),
      });
      if (!r.ok) throw new Error(String(r.status));
      return r.json() as Promise<LogRow[]>;
    },
  });
  return (
    <div className="p-6 max-w-5xl mx-auto">
      <header className="mb-5">
        <h1 className="text-2xl font-semibold text-slate-800">{t("accessLogs.title")}</h1>
        <p className="text-xs text-slate-500 mt-1">{t("accessLogs.hint")}</p>
      </header>
      <div className="rounded-lg border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-2 font-medium">{t("accessLogs.cols.when")}</th>
              <th className="text-left px-4 py-2 font-medium">{t("accessLogs.cols.accessor")}</th>
              <th className="text-left px-4 py-2 font-medium">{t("accessLogs.cols.teacher")}</th>
              <th className="text-left px-4 py-2 font-medium">{t("accessLogs.cols.reason")}</th>
            </tr>
          </thead>
          <tbody>
            {(logs.data ?? []).map((l) => (
              <tr key={l.id} className="border-t border-slate-100">
                <td className="px-4 py-2.5 text-xs text-slate-400 whitespace-nowrap">
                  {l.accessed_at.slice(0, 16).replace("T", " ")}
                </td>
                <td className="px-4 py-2.5 text-slate-800">{l.accessor}</td>
                <td className="px-4 py-2.5 text-slate-600">{l.teacher}</td>
                <td className="px-4 py-2.5 text-slate-600">{l.reason}</td>
              </tr>
            ))}
            {(logs.data ?? []).length === 0 && (
              <tr><td colSpan={4} className="px-4 py-6 text-center text-sm text-slate-400">
                {t("accessLogs.empty")}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
